var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_3496)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83 11.5V4.43H8.55C8.93 4.43 9.27667 4.47 9.59 4.55C9.90333 4.62333 10.1767 4.74667 10.41 4.92C10.6433 5.08667 10.8233 5.31333 10.95 5.6C11.0767 5.88667 11.14 6.24 11.14 6.66C11.14 7.04 11.0733 7.36667 10.94 7.64C10.8067 7.91333 10.6233 8.14 10.39 8.32C10.1567 8.5 9.89333 8.63667 9.6 8.73L11.11 11.5H9.94L8.54 8.9H6.89V11.5H5.83ZM6.89 7.95H8.33C8.57 7.95 8.79333 7.93333 9 7.9C9.21333 7.86 9.4 7.79333 9.56 7.7C9.72 7.6 9.84333 7.46667 9.93 7.3C10.0233 7.12667 10.07 6.90667 10.07 6.64C10.0767 6.33333 10.0167 6.09 9.89 5.91C9.77 5.72333 9.59 5.59333 9.35 5.52C9.11 5.44 8.82 5.4 8.48 5.4H6.89V7.95ZM15.3297 11.58C14.663 11.58 14.1164 11.4467 13.6897 11.18C13.2697 10.9067 12.9597 10.5333 12.7597 10.06C12.5597 9.58667 12.4597 9.03667 12.4597 8.41V4.43H13.5197V8.42C13.5197 8.81333 13.5764 9.17667 13.6897 9.51C13.803 9.84333 13.993 10.11 14.2597 10.31C14.5264 10.51 14.8864 10.61 15.3397 10.61C15.7997 10.61 16.1597 10.51 16.4197 10.31C16.6797 10.11 16.863 9.84333 16.9697 9.51C17.0764 9.17667 17.1297 8.81333 17.1297 8.42V4.43H18.1997V8.41C18.1997 9.03 18.0997 9.58 17.8997 10.06C17.6997 10.5333 17.3897 10.9067 16.9697 11.18C16.5497 11.4467 16.003 11.58 15.3297 11.58Z",
    fill: "#818181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_3496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.177c98b0e9c7b1f7b9c26638eef3f353.svg";
export { ForwardRef as ReactComponent };